import gql from 'graphql-tag';

export default gql`
  query getUserProfile($id: String!, $userToken: String!) {
    userProfile(id: $id, userToken: $userToken) {
      id
      followList {
        id
        items
      }
      watchList {
        id
        items
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/getUserProfile.ts